import Helper from '@ember/component/helper';

export default class ObjectCreatorHelper extends Helper {
    compute(params, hash) {
        return hash;
    }
}
